module.exports = require("./su.d.ts");